import {
  DocumentNode,
  LazyQueryHookOptions,
  OperationVariables,
  useLazyQuery,
  useQuery,
} from "@apollo/client"
import { useMemo } from "react"
import { apolloClient, config, UseQueryOptions } from "@oysterhr/core"

export function usePublicCostCalculatorQuery<
  TData = unknown,
  TVariables extends OperationVariables = OperationVariables,
>(query: DocumentNode, options?: UseQueryOptions<TData, TVariables>) {
  const apolloClientCostCalculator = useMemo(
    () =>
      apolloClient({ csrfToken: "", uri: `${config.endpoints.app}/api/graphql/cost-calculator` }),
    [],
  )
  const result = useQuery(query, { ...options, client: apolloClientCostCalculator })
  return result
}

export function useLazyPublicCostCalculatorQuery<
  TData = unknown,
  TVariables extends OperationVariables = OperationVariables,
>(query: DocumentNode, options?: LazyQueryHookOptions<TData, TVariables>) {
  const apolloClientCostCalculator = useMemo(
    () =>
      apolloClient({ csrfToken: "", uri: `${config.endpoints.app}/api/graphql/cost-calculator` }),
    [],
  )
  return useLazyQuery(query, { ...options, client: apolloClientCostCalculator })
}
